import { Button, Heading, Text } from "@instacover/ui"
import { createFileRoute, Link } from "@tanstack/react-router"
import { Trans, useTranslation } from "react-i18next"

import { ExtraIcons } from "../../../../components/icons/InstructionImageType"
import { ImageLayout } from "../../../../components/layouts/ImageLayout"
import { DispatchRemoteLog } from "../../../../helpers/hooks/useRemoteLogger"
import { LINKS } from "../../../../routing/links"

export const Route = createFileRoute("/$sessionId/_session/errors/incompatible-device")({
  component: CameraFailure,
})

function CameraFailure() {
  const { t } = useTranslation()
  const { sessionId } = Route.useParams()

  return (
    <>
      <DispatchRemoteLog type="APP_ERROR" report={{ type: "pageload", location: "cameraFailure" }} />

      <ImageLayout
        iconName={ExtraIcons.IncompatiblePhone}
        content={
          <>
            <Heading as="h2" variant="h1">
              {t("error.incompatiblePhone.heading")}
            </Heading>

            <div className="h-6 w-6 shrink-0" />

            <Text>
              <Trans
                i18nKey="error.incompatiblePhone.text"
                components={{
                  a: <a className="underline" />,
                }}
              />
            </Text>
          </>
        }
        footer={
          <div className="mt-4 mb-8">
            <Link to={LINKS.guide(sessionId)} className="mt-4 mb-8">
              <Button as="span" variant="secondary">
                {t("error.incompatiblePhone.button")}
              </Button>
            </Link>
          </div>
        }
      />
    </>
  )
}
